import { Component } from 'react'
import styles from '~/styles/ordersPage.input.module.css'
import types from '~/types/ordersPage.ts'

export default class Input extends Component {
	static getInitialProps() {
		return {
			namespacesRequired: [ 'Orders', 'common' ],
		}
	}
	
	constructor(props) {
		super(props)
		let state = {}
		if (!this.props.onChange) {
			state.value = this.props.value
		} else if (this.props.hasOwnProperty('initial')) {
			state.value = this.props.initial
		} else if (this.props.hasOwnProperty('updatedValue')) {
			state.value = this.props.updatedValue
		}
		this.state = state
		if (this.props.valueSetterInit) {
			this.props.valueSetterInit(this._setValue.bind(this))
		}
	}
	
	render(): JSX.Element {
		let value = this.state?.value
		if (this.props.onChange && !this.props.hasOwnProperty('initial')) {
			value = this.props.value
		}
		let isRequired = false
		if (typeof this.props.isRequiredFunction === 'function') {
			isRequired = this.props.isRequiredFunction(value)
		}
		let mainStyle = {}
		if (this.props.marginLeftRem) {
			mainStyle.marginLeft = this.props.marginLeftRem + 'rem'
		}
		let frameStyle = {}
		if (this.props.widthRem) {
			frameStyle.width = this.props.widthRem + 'rem'
		}
		let inputAndAfterClass = styles.inputAndAfter
		if (this.props.isRequiredSignInside) {
			inputAndAfterClass += ' ' + styles.insideRequiredFrame
		}
		if (this.props.totalDisabled) {
			inputAndAfterClass += ' ' + styles.totalDisabled
		}
		return (
			<div
				className={styles.main + (this.props.centered ? ' ' + styles.centered : '')}
				style={mainStyle}
			>
				{this._getTitle()}
				<div
					className={inputAndAfterClass}
					style={frameStyle}
				>
					<input
						type={this.props.type || 'number'}
						name={this.props.name || null}
						placeholder={this.props.placeholder || ''}
						step={this.props.step || null}
						min={this.props.min || null}
						max={this.props.max || null}
						pattern={this.props.pattern || null}
						value={value}
						onChange={this._onChange.bind(this)}
						onFocus={this._onFocus.bind(this)}
						onKeyDown={this._onKeyDown.bind(this)}
						ref={this.props.setRef || null}
						disabled={this.props.disabled || null}
						onDragStart={(event) => event.preventDefault()}
					/>
					{this._getAfter()}
				</div>
				<div
					className={isRequired ? (this.props.isRequiredSignInside ? styles.insideRequired : styles.required) : styles.hidden}
				>
					{this.props.t('common:Required')}
				</div>
			</div>
		)
	}
	
	private _setValue(value): JSX.Element | null {
		this.setState({ value })
	}

	private _getTitle(): JSX.Element | null {
		const className = this.props.isRequiredSignInside ? styles.labelHigh : null
		if (this.props.label) {
			return (
				<label
					className={className}
				>
					{this.props.label}
				</label>
			)
		} else {
			return null
		}
	}
	private _getAfter(): JSX.Element | null {
		if (this.props.after) {
			return (
				<div
					className={styles.after}
					after={this.props.after}
				/>
			)
		} else {
			return null
		}
	}
	
	private _onFocus(event): void {
		if (this.props.focused) {
			event.target.select()
		}
	}
	
	private _onChange(event): void {
		const value = this._getValue(event)
		if (this.props.onChange) {
			if (this.props.hasOwnProperty('initial')) {
				this.setState({ value })
				if (this._onPointsST) {
					clearTimeout(this._onPointsST)
				}
				this._onPointsST = setTimeout(() => {
					this.props.onChange(value)
				}, 300)
			} else {
				this.props.onChange(value)
			}
		} else {
			this.setState({ value })
		}
	}

	private _onKeyDown(event): void {
		if (this.props.onEnter && event?.keyCode === 13) {
			const value = this._getValue(event)
			this.props.onEnter(value)
		}
	}

	private _getValue(event): void {
		let value = event?.target?.value
		if (this.props.hasOwnProperty('maxToLb')) {
			if (+value !== (+this.props.maxToLb + 1)) {
				if (+value > +this.props.maxToLb) {
					const string = (value + '')
					const lastCharacter = string.substring(string.length - 1, string.length)
					value = +lastCharacter
				}
			}
		}
		if (this.props.hasOwnProperty('minToLb')) {
			if (+value !== (+this.props.minToLb - 1)) {
				if (+value < +this.props.minToLb) {
					value = this.props.minToLb
				}
			}
		}
		if (this.props.type === 'number' || !this.props.type) {
			if ((event.target.value + '').startsWith('0')) {
				event.target.value = +((event.target.value + '').replace(/^[0]+/g, ''))
			}
			if (event.target.value) {
				value = +value
			} else {
				if (this.state?.value < 10) {
					value = ''
				} else {
					value = this.state?.value || ''
				}
			}
		}
		if (this.props.hasOwnProperty('maxToLb')) {
			if (value > (this.props.maxToLb + 1)) {
				const string = (value + '')
				value = string.substring(string.length - 1)
			}
		} else {
			if (this.props.step) {
				if ((this.props.step + '') === '1') {
					value = Math.round(value)
				} else if (this.props.step.length >= 3) {
					const handred = Math.pow(10, (this.props.step.length - 2))
					// Math.floor(4567.15 * 100) / 100 === 4567.14
					value = Math.floor((value + Number.EPSILON * 1000000000) * handred) / handred
				}
			}
		}
		return value
	}
}